import { TabelaPreco } from "../types/tabela_preco";

export const novaTabelaPreco = (): TabelaPreco => {
  return {
    nome: "",
    itens: [],
  };
};
